<template>
  <resource-show-wrapper :title="item ? item.name : ''" :label="$t('resources.domains.show.label')">
    <va-tabs :selected-tab="selectedTab" :items="tabItems" @change="tabChange">
      <template v-slot:[`pages`]>
        <!--        Pages List -->
        <pages-resource-list
          class="mt-6 pages__list"
          :list-page="false"
          :domain-id="item.id"
          :list-title="$t('resources.domains.pages')"
          :list-sub-title="$t('resources.domains.pages_sub_title')"
          resource-name="pages"
          :active-filter-onload="{ domain: [item.id] }"
          :alternative-view="true"></pages-resource-list>
      </template>
      <template v-slot:[`page_categories`]>
        <!--        Page categories List -->
        <page-categories-resource-list
          class="mt-6 page_categories__list"
          :list-page="false"
          :domain-id="item.id"
          resource-name="page_categories"
          :active-filter-onload="{ domain: [item.id] }">
        </page-categories-resource-list>
      </template>
      <template v-slot:[`pages_add_ons`]>
        <!--        Modals List -->
        <modals-resource-list
          class="mt-6 popups__list"
          :domain-id="item.id"
          :list-page="false"
          resource-name="modals"
          :active-filter-onload="{ domain: [item.id] }">
        </modals-resource-list>
        <!--        Favorites blocks List -->
        <favorites-blocks-resource-list
          class="mt-6 favorites_blocks__list"
          :domain-id="item.id"
          :list-page="false"
          resource-name="favorites_blocks"
          :active-filter-onload="{ domain: [item.id] }">
        </favorites-blocks-resource-list>
        <!--        Sidebars List -->
        <sidebars-resource-list
          class="mt-6 sidebars__list"
          :domain-id="item.id"
          :list-page="false"
          resource-name="sidebars"
          :active-filter-onload="{ domain: [item.id] }">
        </sidebars-resource-list>
      </template>
      <template v-slot:[`page_elements`]>
        <design-elements :domain-id="item.id"></design-elements>
      </template>
      <template v-slot:[`domain_settings`]>
        <domain-settings :domain="item"></domain-settings>
      </template>
    </va-tabs>
  </resource-show-wrapper>
</template>

<script>
  import definedAbility from "@/ability";
  import ResourceShowWrapper from "@/components/resourceWrappers/ResourceShowWrapper";
  import VaTabs from "@/components/custom/VaTabs";
  import ModalsResourceList from "@/resources/modals/List";
  import FavoritesBlocksResourceList from "@/resources/favorites-blocks/List";
  import SidebarsResourceList from "@/resources/sidebars/List";
  import PageCategoriesResourceList from "@/resources/page-categories/List";
  import PagesResourceList from "@/resources/pages/List";

  /** Icons */
  import PagesIcon from "@/components/icons/PagesIcon";
  import CogIcon from "@/components/icons/CogIcon";
  import ShapeOutlineIcon from "@/components/icons/ShapeOutlineIcon";
  import ShapeSquareIcon from "@/components/icons/ShapeSquareIcon";
  import PencilRulerIcon from "@/components/icons/PencilRulerIcon";

  /** Tabs components */
  import DomainSettings from "@/components/tabs/domains/DomainSettings";
  import DesignElements from "@/components/tabs/domains/DesignElements";
  import { DOMAIN_STATUS } from "@/constant";

  export default {
    components: {
      ResourceShowWrapper,
      VaTabs,
      DomainSettings,
      DesignElements,
      ModalsResourceList,
      FavoritesBlocksResourceList,
      SidebarsResourceList,
      PageCategoriesResourceList,
      PagesResourceList,
    },
    props: {
      /** Injected by VA-admin */
      item: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        ability: definedAbility(),
        selectedTab: this.$route?.query?.tab || "pages",
        tabItems: [],
      };
    },
    beforeMount() {
      if (this.item?.status === DOMAIN_STATUS.CONNECTED) {
        this.tabItems = [
          {
            title: "Pages",
            icon: PagesIcon,
            tabName: "pages",
          },
          {
            title: "Page add-ons",
            icon: ShapeSquareIcon,
            tabName: "pages_add_ons",
          },
          {
            title: "Page elements",
            icon: PencilRulerIcon,
            tabName: "page_elements",
          },
          {
            title: "Domain settings",
            icon: CogIcon,
            tabName: "domain_settings",
          },
        ];

        if (this.ability.can("view", "page categories")) {
          this.tabItems.splice(1, 0, {
            title: "Page Categories",
            icon: ShapeOutlineIcon,
            tabName: "page_categories",
          });
        }
      } else {
        this.tabItems = [
          {
            title: "Domain settings",
            icon: CogIcon,
            tabName: "domain_settings",
          },
        ];
      }
    },
    methods: {
      tabChange(newTab) {
        this.$router.replace({ query: { tab: newTab } });
        this.$store.commit("SET_PREVIOUS_ROUTE", this.$route.fullPath);
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../../@core/preset/preset/typography/index.scss";

  ::v-deep {
    .popups__list,
    .favorites_blocks__list,
    .pages__list,
    .sidebars__list,
    .page_categories__list {
      .list__heading {
        &-title-wrapper {
          margin-bottom: 6px;
        }
        h1 {
          @include heading-3();
        }
      }
    }
  }
</style>
